import React from "react";
import CategoryPieChart from "./components/CategoryPieChart";
import CustomCard from "../Card";

const CaseCategory: React.FC = React.memo(() => {
  return (
    <CustomCard heading="CASE /" subHeading="CATEGORY">
      <CategoryPieChart />
    </CustomCard>
  );
});

export default CaseCategory;
